'use client'
import React from 'react'
import Image from 'next/image'
import clientVersion from '../../../../common/version.json'
import ProgressBar from 'app/app/(client)/components/molecules/ProgressBar/ProgressBar'
import Text from '../../atoms/Text/Text'
import Button from '../../atoms/Button/Button'
import Icon from '../../atoms/Icon/Icon'
import { ProgressStatus } from 'app/app/(client)/utils/client-constants'
import { getIcon } from 'app/app/(client)/utils/utils'
import { t } from 'i18next'

interface LoadingPageProps {
  percentage: number
  loaderText?: string
  label?: string
  variant?: ProgressStatus.LOADING | ProgressStatus.FAILURE | ProgressStatus.SUCCESS
  appName: string
  errorMessage: string
  errorCode?: string | number
  errorStack?: string
  onRetry?: () => void
}

const LoadingPage: React.FC<LoadingPageProps> = (props: LoadingPageProps) => (
  <div className="loading-container">
    <div className="loading-inner">
      <div className="app-details-container ">
        <Image src={'/images/logo/logo_primary.svg'} alt="KONE Logo" width={179} height={70} className="brand-image" />
        <h3 className="branding-name">Kone Care Contract</h3>
        <Text className="app-name">{props.appName}</Text>
        {typeof window !== 'undefined' && window.version ? (
          <>
            <Text className="version-text">{`client-version: ${clientVersion.version}`}</Text>
            <Text className="version-text">{`server-version: ${window.version}`}</Text>
          </>
        ) : null}
      </div>

      <div className="progress-container">
        <ProgressBar
          value={props.percentage}
          label={props.label}
          variant={props.variant || ProgressStatus.LOADING}
          progressValueVisible={false}
        />
      </div>
      {props.errorMessage && (
        <div className="w-full max-w-2xl px-4">
          <div className="flex flex-col gap-2 rounded p-4">
            <div className="flex items-start gap-3">
              <Icon name={getIcon('error')} className="text-invalid text-24px mt-0.5 shrink-0" />
              <div className="flex items-baseline gap-2 flex-1 min-w-0">
                {props.errorCode ? (
                  <Text className="text-xs font-semibold text-invalid shrink-0">[{props.errorCode}]</Text>
                ) : null}
                <Text className="text-sm text-gray-700">{props.errorMessage}</Text>
              </div>
            </div>
            {props.errorStack ? (
              <pre className="text-xs text-gray-600 whitespace-pre-wrap wrap-break-word bg-gray-50 rounded max-h-24 overflow-y-auto">
                {props.errorStack}
              </pre>
            ) : null}
            {props.onRetry ? (
              <div className="flex justify-end">
                <Button
                  id="loading-page-retry-btn"
                  variant="primary"
                  size="xsmall"
                  className="btn"
                  onClick={props.onRetry}
                >
                  {t('errors.tryAgain') || 'Try again'}
                </Button>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </div>
  </div>
)

export default LoadingPage
